import DeleteIcon from "@mui/icons-material/Delete";
import { Typography } from "@mui/material";
import { useFornecedores } from "../../services";
import { Fornecedores } from "../../types";
import { memoObserver } from "../../utils/memoObserver.utils";
import { CDialog } from "../data-display";

interface ModalDeletePacotesProps {
  data: Fornecedores;
}

export const ModalDeleteFornecedores = memoObserver(
  ({ data }: ModalDeletePacotesProps) => {
    const { deleteFornecedor } = useFornecedores();

    const handleDelete = async () => {
      await deleteFornecedor(data);
    };

    return (
      <CDialog
        title="Deletando Item"
        onSave={handleDelete}
        iconButton={<DeleteIcon color="error" />}
        type="error"
      >
        <Typography variant="subtitle1">
          Você tem certeza que deseja deletar o item {data.nome}?
        </Typography>
      </CDialog>
    );
  }
);
